import {DropDown} from "components/dropdown";
import {validateSignUpForm} from "../../helpers/validations";

import "./index.scss";
import {resetCheckBox} from "vendor/svgcheckbx";

export default function () {
    $('.signup-news-letters-2')
        .each((index, component) => {
            const id = Math.round(Math.random() * 100000);
            const $component = $(component);

            const $form = $component.find('form');

            new DropDown($('#drop-dd-languages'));

            $form.on('submit', (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
                event.stopPropagation();

                if (!validateSignUpForm($form)) {
                    return false;
                }

                $form.find('input').prop('disabled', true);

                let groupHtml = '';
                const lists = $form.find('#newsletterList input[type=checkbox]');
                if (lists.length > 1) {
                    $form.find('#newsletterList input[type=checkbox]')
                        .each((index, checkbox) => {
                            if (checkbox.checked) {
                                const values = checkbox.value.split('/');
                                const group = values[0];
                                const groupIndex = values[1];
                                const value = Math.pow(2, groupIndex);
                                groupHtml += `<input type="hidden" value="${value}" name="group[${group}][${value}]" id="mce-group[${group}]-${group}-${groupIndex}">`;
                            }
                        });
                } else {
                    const values = $component.data('default-interest').split('/');
                    const group = values[0];
                    const groupIndex = values[1];
                    const value = Math.pow(2, groupIndex);
                    groupHtml += `<input type="hidden" value="${value}" name="group[${group}][${value}]" id="mce-group[${group}]-${group}-${groupIndex}">`;
                }

                const iframe = document.createElement('iframe');
                const html =
                    `<!DOCTYPE html>
<html>
<head>
<link href="//cdn-images.mailchimp.com/embedcode/classic-10_7.css" rel="stylesheet" type="text/css">
<link href="/dist/main.css" rel="stylesheet" />
<style type="text/css">
</style>
</head>
<body onload="onPageLoad()">
<div id="mc_embed_signup" style="margin-top: 0;">
<form action="${$form.data('url')}" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
    <div id="mc_embed_signup_scroll">
      <div class="mc-field-group">
        <input type="hidden" value="${$form.find("input[name='EMAIL']").val()}" name="EMAIL" class="required email" id="mce-EMAIL">
        <input type="hidden" value="${$form.find("input[name='FNAME']").val()}" name="FNAME" class="" id="mce-FNAME">
        <input type="hidden" value="${$form.find("input[name='LNAME']").val()}" name="LNAME" class="" id="mce-LNAME">
        <input type="hidden" value="${$form.find("input[name='COMPA']").val()}" name="COMPA" class="required email" id="mce-COMPANY">
        <input type="hidden" value="${$form.find("input[name='TITLE']").val()}" name="TITLE" class="" id="mce-TITLE">
        <input type="hidden" value="${$form.find("input[name='LANG']").val()}" name="LANG" class="" id="mce-LANG">
        ${groupHtml}
        <input type="hidden" id="gdpr_10917" name="${$form.find("input#gdpr_id").attr('name')}" value="Y" class="av-checkbox ">
      </div>
      <div id="mce-responses" class="clear">
        <div class="response" id="mce-error-response" style="display:none"></div>
        <div class="response" id="mce-success-response" style="display:none"></div>
      </div>
          <!--<div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_a62a5d4295a2d649657f91cf3_850893fe35" tabindex="-1" value=""></div>-->
      <div class="clear"><input type="submit" value="" name="subscribe" id="mc-embedded-subscribe" class="button" style="width: 0; height: 0; position: absolute; opacity: 0.001;"></div>
    </div>
</form>
</div>
<script type='text/javascript' src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script>
<script type='text/javascript'>
function onPageLoad(){
(function($) {window.fnames = [];window.ftypes = [];fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';}(jQuery));
var $mcj = jQuery.noConflict(true);
$mcj(function(){
  //$mcj('#mc-embedded-subscribe-form').trigger('submit');
  $mcj('#mc-embedded-subscribe').trigger('click');
  
  var $error = $mcj('#mce-error-response');
  var $success = $mcj('#mce-success-response');
  var interval = setInterval(function() {
    const success = $success.html();
    const error = $error.html();
    
    $mcj('#mce-responses a')
      .prop('target', '_blank');
    
    if (success || error) {
      clearInterval(interval);
      window.parent.formSubmitted${id}(success, error);
    }
  }, 1000);
});
}
</script>
<!--End mc_embed_signup-->
</body>
</html>`;

                const $responses = $form.find('#mce-responses');
                $responses.html('');

                $responses[0].appendChild(iframe);
                iframe.scrolling = 'no';
                iframe.style.border = 'none';
                iframe.style.overflow = 'hidden';
                iframe.style.position = 'relative';
                iframe.style.width = '100%';
                iframe.style.height= '0px';
                iframe.height= '0px';
                iframe.contentWindow.document.open();
                iframe.contentWindow.document.write(html);
                iframe.contentWindow.document.close();

                window[`formSubmitted${id}`] = function (success, error) {
                    $form.find('input')
                        .prop('disabled', false);

                    //$(iframe).remove();
                   // $responses.hide();
                    $('#signupSolutionPopMessage .su-message').hide();
                    if (success) {
                        $form.find('input[type="checkbox"]')
                            .prop('checked', false)
                            .each((index, checkBox) => {
                                resetCheckBox(checkBox);
                            });

                        $form.find('input[type="text"]')
                            .val(null);

                        $('#signupSolutionPopMessage .su-success-message').show();
                    } else {
                        $('#signupSolutionPopMessage .su-error-message').show();
                    }
                    $('#signupSolutionPopMessage').modal('show');
                };

                event.preventDefault();

                return false;
            });

            $component
                .find('input.input__field')
                .each((index, input) => {
                    const $input = $(input);
                    const value = input.value.trim();

                    if (value !== '') {
                        $input.parent().addClass('input--filled');
                    }

                    $input.on('focus', () => {
                        $input.parent().addClass('input--filled');
                    });

                    $input.on('blur', () => {
                        if (input.value.trim() === '') {
                            $input.parent().removeClass('input--filled');
                        }
                    });
                });
        });
}
